import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import EventDetailPage from "@/pages/EventDetailPage";

export const Route = createFileRoute("/es/eventos/$slug")({
  loader: ({ params }) => loadContentMeta("events", params.slug, "es"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/es/eventos/${params.slug}`, loaderData),
  component: EventDetailPage,
});

